import { Grid, GridProps } from '@mui/material'
import React from 'react'

const GridWrapper = React.forwardRef<HTMLDivElement, GridProps>(({ children, ...props }, ref) => (
  <Grid {...props} ref={ref} children={children} />
))

export default GridWrapper
